import { render, staticRenderFns } from "./OtherTexts.vue?vue&type=template&id=ce0883ac&"
import script from "./OtherTexts.vue?vue&type=script&lang=js&"
export * from "./OtherTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports